import { useQuery } from "@tanstack/react-query";

import { JsonLd } from "@/components/json-ld";
import {
  getArtistDirectoryQueryOptions,
  type ArtistDirectoryIdentity,
  type ArtistDirectorySearchState,
} from "@/features/feature-page/artist-directory-query";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";
import { buildAppLink } from "@garimpa/lib/buildAppLink";

export function ArtistDirectoryStructuredData({
  page,
  directory,
  search,
}: {
  page: FeaturePageRenderModel;
  directory: ArtistDirectoryIdentity;
  search: ArtistDirectorySearchState;
}) {
  const result = useQuery(getArtistDirectoryQueryOptions(directory, search));
  const graph = page.structuredData["@graph"];
  if (
    Object.values(search).some((value) => value !== undefined) ||
    !result.data ||
    !Array.isArray(graph) ||
    typeof graph[0] !== "object" ||
    graph[0] === null
  ) {
    return null;
  }

  const itemListElement = result.data.artists.map((artist, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: artist.name,
    url: buildAppLink(["artist", artist.id]),
  }));
  const structuredData = {
    ...page.structuredData,
    "@graph": [
      {
        ...graph[0],
        mainEntity: { "@type": "ItemList", itemListElement },
      },
      ...graph.slice(1),
    ],
  };

  return <JsonLd data={structuredData} />;
}
